// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__2SAdq","text":"styles-m__text__39Bh0"};